import React from "react";
import "./FastGamePlayPageStyle.scss";
import { fastGamePlayTextContent } from "./constant/index";
import { slotGameInfoTextContent } from "../SlotGameInfo/constant/index";
import MainLayout from "../../components/MainLayout";
import GameDetailsListSection from "../../components/GameDetailsListSection";
import AboutGameSection from "../../components/AboutGameSection";
import FastGamesSection from "../../components/FastGamesSection";
import CustomButton from "../../components/Common_UI_Kit/CustomButton";
import ArrowLeftIcon from "../../assets/icons/Arrow-Left";
import FullScreenIcon from "../../assets/icons/Full-Screen";
import { useNavigate } from "react-router-dom";

const FastGamePlayPage = () => {
  const navigate = useNavigate();

  const handleBackClick = () => {
    navigate(-1);
  };

  return (
    <MainLayout>
      <div className="fast-game-play-page">
        <div className="game-img-wrap">
          <div className="game-img-box">
            <img src={fastGamePlayTextContent.imgSrcGame} alt="Image" />
          </div>

          <div className="btn-box">
            <CustomButton
              startIcon={<ArrowLeftIcon />}
              label={fastGamePlayTextContent.backBtnText}
              className="back-btn"
              onClick={handleBackClick}
            />
            <CustomButton
              startIcon={<FullScreenIcon />}
              label={fastGamePlayTextContent.fullscreenBtnText}
              className="fullscreen-btn"
            />
          </div>
        </div>

        <AboutGameSection
          paragraphText={fastGamePlayTextContent.paragraphText}
          listItemTitle={fastGamePlayTextContent.listItemTitle}
          listText={fastGamePlayTextContent.listText}
        />

        <FastGamesSection
          sectionHeadingText={fastGamePlayTextContent.headingText}
        />
      </div>
    </MainLayout>
  );
};

export default FastGamePlayPage;
